module.exports = __webpack_public_path__ + "static/img/appLogoT.9d44090.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/appLogoT.png
// module id = 9Itc
// module chunks = 1